import { Link, useLocation } from "react-router-dom";

const navItems = [
  { name: "Home", path: "/" },
  { name: "Products", path: "/products" },
  { name: "Insights", path: "/insights" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
];

export default function Header() {
  const { pathname } = useLocation();
  
  return (
    <header className="bg-linear-to-r from-sky-700 to-blue-600 text-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4 flex flex-col md:flex-row justify-between items-center gap-4">
        
        {/* Logo + Brand */}
        <Link to="/" className="flex items-center space-x-3 group">
          {/* Logo Icon - scaled to match title height */}
          <img 
            src="/zero-harm-ai-logo.png" 
            alt="Zero Harm AI logo" 
            className="h-12 w-auto object-contain group-hover:scale-105 transition-transform"
          />
          <div className="flex flex-col">
            <span className="text-2xl font-bold tracking-tight">Zero Harm AI</span>
            <span className="text-xs text-blue-100">Agentic AI &amp; AI Security Development</span>
          </div>
        </Link>

        {/* Navigation */}
        <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2">
          {navItems.map(({ name, path }) => (
            <Link
              key={path}
              to={path}
              className={`text-lg font-medium transition-all ${
                pathname === path
                  ? "text-white font-bold underline decoration-2 underline-offset-8"
                  : "text-white hover:text-blue-100"
              }`}
            >
              {name}
            </Link>
          ))}
        </nav>

        {/* CTA Button */}
        <Link
          to="/contact"
          className="px-6 py-2 bg-white text-blue-700 rounded-lg hover:bg-blue-50 font-bold transition-all shadow-lg hover:shadow-xl transform hover:scale-105 hidden md:block"
        >
          Get Started
        </Link>
      </div>
    </header>
  );
}
